module.exports = __webpack_public_path__ + "ddc261db9e87bde66b5b6a483750630c.jpg";